export default __webpack_public_path__ + "static/media/sidebar-4.ab008ac3.jpg";